// extracted by mini-css-extract-plugin
module.exports = {"versions-download":"versions-download_versions-download__hXkGI","versions-download__upgrade-to-unlock":"versions-download_versions-download__upgrade-to-unlock__LiSXp"};